export default "__VITE_ASSET__D98c375P__"